// @flow
import React from "react";
import Table from "containers/Table";
// import TableCell from "@material-ui/core/TableCell";
// import MaterialLink from "components/MaterialLink";
import type { CellProps } from "containers/Table/types";

const TableTshirtStaff = (props) => {
  const columns = [
    {
      name: "staffName",
      title: "Name",
      sortable: true,
      filterable: true,
      active: true,
    },
    {
      name: "tshirtSize",
      title: "Shirt Size",
      sortable: true,
      filterable: false,
      active: true,
    },
    {
      name: "role",
      title: "Role",
      sortable: true,
      filterable: true,
      active: true,
    },
  ];
  const defaultColumnWidths = [
    { columnName: "staffName", width: "300px" },
    { columnName: "tshirtSize", width: "200px" },
    { columnName: "role", width: "200px" },
  ];
  // To-DO: Make this staffName redirect to the persons profile on click.
  const template = (cell: CellProps) => {
    // const { row, column } = cell;
    // if (column.name === "staffName") {
    //   return (
    //     <TableCell>
    //       <MaterialLink to={`/private/profile/${row.personId}`}>
    //         {row.staffName}
    //       </MaterialLink>
    //     </TableCell>
    //   );
    // }
    return undefined;
  };
  return (
    <Table
      title="Staff Tshirts"
      url={props.tshirtURL}
      exportUrl={props.exportURL}
      columns={columns}
      defaultColumnWidths={defaultColumnWidths}
      template={template}
    />
  );
};

export default TableTshirtStaff;
